import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["loading", "onChange", "open", "options"],
  _excluded2 = ["children", "option"];
import { useCallback, useMemo } from 'react';
import styled, { ThemeProvider, useTheme } from 'styled-components';
import classNames from 'classnames';
import UITypeahead from 'UIComponents/typeahead/UITypeahead';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "MobileTypeaheadResults__StyledWrapper",
  componentId: "sc-1e2g51n-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return {
    width: '100%',
    '.mobile-typeahead-search-results': {
      'padding-top': '16px',
      'max-height': 'unset',
      'background-color': `${theme.color['fill-surface-default']}`,
      'z-index': '1221',
      'ul[role="listbox"]': {
        '.mobile-typeahead-item': {
          'padding-inline-start': '0'
        }
      },
      '.mobile-typeahead-group': {
        'background-color': `${theme.color['fill-tertiary-hover']}`
      }
    }
  };
});
const Spinner = () => {
  return /*#__PURE__*/_jsx(LoadingSpinner, {
    grow: true
  });
};
function getMappedOptions(options) {
  return options.map(option => {
    if ('options' in option) {
      return Object.assign({}, option, {
        dropdownClassName: classNames(option.dropdownClassName, 'mobile-typeahead-group'),
        options: getMappedOptions(option.options)
      });
    }
    return Object.assign({}, option, {
      dropdownClassName: classNames(option.dropdownClassName, 'mobile-typeahead-item')
    });
  });
}
export default function MobileTypeaheadResults(_ref) {
  let {
      loading,
      onChange,
      open = true,
      options
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const mappedOptions = useMemo(() => getMappedOptions(options), [options]);
  const TypeaheadItem = useCallback(_ref2 => {
    let {
        children,
        option
      } = _ref2,
      rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    return /*#__PURE__*/_jsx("li", Object.assign({}, rest, {
      onClick: () => {
        onChange(option);
      },
      children: children
    }));
  }, [onChange]);
  const theme = useTheme();
  return /*#__PURE__*/_jsx(ThemeProvider, {
    theme: theme,
    children: /*#__PURE__*/_jsx(StyledWrapper, {
      children: /*#__PURE__*/_jsx(UITypeahead, Object.assign({}, props, {
        hideResults: !open,
        itemComponent: loading ? Spinner : TypeaheadItem,
        options: loading ? [] : mappedOptions,
        resultsClassName: "mobile-typeahead-search-results",
        searchClassName: "hidden"
      }))
    })
  });
}